let overrideMethod

export function getOverrideMethod() {
  return overrideMethod
}

export function setOverrideMethod(fn) {
  overrideMethod = fn
}

export default {
  getOverrideMethod,
  setOverrideMethod,
}
